import { apiClient } from "helpers/api_helper";

export const getAllPaymentTypeData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Payment/GetAllPaymentType`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
